export const FETCH_MAILS = "FETCH_MAILS";
export const LOAD_MORE_MAILS = "LOAD_MORE_MAILS";
